import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, MicrositeActionCreators, IMicrositeCountResponse, IAppState } from '@nkr/store/index';
import { MicrositeListType, UserGroup, DonorShieldStatus, OrganType } from '@nkr/enums/index';
import { ICenter, micrositeListTypeMap } from '@nkr/models/index';
import { IMicrositeCounts } from '@nkr/models/index';
import DonorsNav from '@nkr/views/donors/tabs';
import MicrositeNav from './nav';
import MicrositeAddEdit from './add-edit';
import EditDemographics from './survey-add-edit';
import MicrositeApprove from './approve';
import MicrositeDecline from './decline';
import MicrositeReactivate from './reactivate';
import MicrositeDeny from './deny';
import CampaignList from './campaigns/list/campaign-list';
import CampaignAddEdit from './campaigns/add-edit';
import CampaignMailingList from './campaigns/mailing-list';
import CampaignMailingListMapping from './campaigns/mailing-list-mapping';
import ConfirmMailingList from './campaigns/confirm-mailing-list';
import UploadSignatureFile from './campaigns/upload-signature-file';
import EditLetter from './campaigns/edit-letter';

import MicrositeProfile from './profile';
import MicrositeList from './list';
import MicrositeRecipientHistory from './microsite-recipient-history';

interface IProps {
    center: ICenter,
    centerId: number,
    activeKey: string,
    isAdmin: boolean,
    itemId?: number,
    onTabSelect: (key: string) => void
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getMicrositeCounts: (centerId: number, liverOnly: boolean) => Promise<IMicrositeCountResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    counts: IMicrositeCounts,
    search: {
        center: number,
        status: number,
        search: string
    },
}

class MicrositeContainer extends React.Component<TProps, IState> {
    readonly state: IState = {
        counts: {
            allCount: 0,
            pendingPatientCount: 0,
            pendingConfirmationCount: 0,
            pendingCoachCount: 0,
            pendingCenterCount: 0,
            pendingNkrCount: 0,
            activeStarterSiteCount: 0,
            activeCustomSiteCount: 0,
            activePostTxpSiteCount: 0,
            disapprovedCount: 0,
            inactiveCount: 0,
            pendingCardsCount: 0,
            campaignCount: 0,
            waitListCount: 0,
            deactivationRequestCount: 0,
            stagnantMicrositeCount: 0
        },
        search: {
            center: 0,
            status: -1,
            search: ''
        },
    }

    componentDidMount = () => {
        this.getData();
    }

    getListType = () => {
        let item = micrositeListTypeMap.find(x => x.url == this.props.activeKey.toLowerCase());

        if (item != null)
            return item.type;

        return MicrositeListType.PendingPatient;
    }

    getPrevious = () => {
        let p = qs.parse(location.search);
        let previous = p.previous;

        let f = micrositeListTypeMap.find(x => x.type == parseInt(previous));

        return f;
    }

    getData = () => {
        let showList = micrositeListTypeMap.find(x => x.url.toUpperCase() == this.props.activeKey.toUpperCase()) != null;
        let isCampaignList = this.props.activeKey == 'CAMPAIGN-LIST';
        let isDeactivationRequest = this.props.activeKey == 'DEACTIVATION-REQUESTS';

        if (showList || isCampaignList || isDeactivationRequest) {
            this.getCounts().then(response => {
                this.props.hideLoading();
            });
        }
    }

    getCounts = () => {
        return this.props.getMicrositeCounts(this.props.centerId, this.props.app.site.organType == OrganType.Liver).then(response => {
            if (response.data.success) {
                this.setState({
                    counts: response.data.results,
                });
            }
        });
    }

    handleSearch = (center: number, status: number, search: string) => {
        this.setState({
            search: {
                center,
                status,
                search
            }
        });
    }

    render = () => {
        const isFollowUpParticipant = this.props.center != null ? this.props.center.isFollowUpParticipant : false;
        const isInDonorShield = this.props.center != null ? this.props.center.isInDonorShield == DonorShieldStatus.On : false;

        const previous = this.getPrevious();
        const previousUrl = previous != null ? previous.url : 'pending-patient';
        const previousName = previous != null ? previous.name : 'Pending Patient';

        const showList = micrositeListTypeMap.find(x => x.url.toUpperCase() == this.props.activeKey.toUpperCase()) != null;

        return (
            <div style={{ padding: '5px 10px' }}>
                <DonorsNav
                    activeKey={'MICROSITES'}
                    centerId={this.props.centerId}
                    isMicrositeParticipant={true}
                    isAdmin={this.props.isAdmin}
                    isFollowUpParticipant={isFollowUpParticipant}
                    isInDonorShield={isInDonorShield}
                    organType={this.props.app.site.organType}
                    onTabSelect={() => null}
                />

                {this.props.activeKey == 'CAMPAIGN' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <CampaignAddEdit
                            campaignId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'CAMPAIGN-MAILING-LIST' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <CampaignMailingList
                            campaignId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'CAMPAIGN-MAILING-LIST-MAPPING' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <CampaignMailingListMapping
                            campaignId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'CONFIRM-MAILING-LIST' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <ConfirmMailingList
                            campaignId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'UPLOAD-SIGNATURE-FILE' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <UploadSignatureFile
                            campaignId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'EDIT-LETTER' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <EditLetter
                            campaignId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'REGISTRATION' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeAddEdit
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            isConfirm={false}
                            previousUrl={previousUrl}
                            previousName={previousName}
                        />
                    </div>
                )}

                {this.props.activeKey == 'DEMOGRAPHIC' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <EditDemographics
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                            previousName={previousName}
                        />
                    </div>
                )}

                {this.props.activeKey == 'CONFIRM' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeAddEdit
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            isConfirm={true}
                            previousUrl={previousUrl}
                            previousName={previousName}
                        />
                    </div>
                )}

                {this.props.activeKey == 'HISTORY' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeRecipientHistory
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'APPROVE' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeApprove
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                            isCoachView={false}
                        />
                    </div>
                )}

                {this.props.activeKey == 'DECLINE' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeDecline
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'REACTIVATE' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeReactivate
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'DENY' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeDeny
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'PROFILE' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeProfile
                            micrositeId={this.props.itemId}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            previousUrl={previousUrl}
                        />
                    </div>
                )}

                {this.props.activeKey == 'CAMPAIGN-LIST' && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "85vh", paddingTop: 0, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <MicrositeNav
                            counts={this.state.counts}
                            activeKey={this.props.activeKey}
                            isAdmin={this.props.isAdmin}
                            isNkrLogin={this.props.app.user.groupId == UserGroup.Admin}
                            isMicrositeCoach={this.props.app.user.isMicrositeCoach}
                            centerId={this.props.centerId}
                        />

                        <CampaignList
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            isNkrLogin={this.props.app.user.groupId == UserGroup.Admin}
                        />
                    </div>
                )}

                {showList && (
                    <>
                        <MicrositeList
                            isAdminLogin={this.props.app.user.group.isSuper}
                            center={this.props.center}
                            centerId={this.props.centerId}
                            activeKey={this.props.activeKey}
                            isAdmin={this.props.isAdmin}
                            counts={this.state.counts}
                            onTabSelect={() => null}
                            onUpdateCounts={this.getCounts}
                        />
                    </>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getMicrositeCounts: (centerId, liverOnly) => {
            return dispatch(MicrositeActionCreators.getMicrositeCounts(centerId, liverOnly));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(MicrositeContainer);